import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import {
	coreSonarTaskConfigsByOrganizationIdAndTaskTypeReducers,
	coreSonarTaskConfigsByOrganizationIdAndTaskTypeWatchers
} from './config';

export const coreSonarTasksByOrganizationIdAndTaskTypeReducers = combineReducers({
	configs: coreSonarTaskConfigsByOrganizationIdAndTaskTypeReducers
});

export const coreSonarTasksByOrganizationIdAndTaskTypeWatchers = combineAllWatchers([
	coreSonarTaskConfigsByOrganizationIdAndTaskTypeWatchers
]);
